const FALLBACK_BASE_URL = 'http://localhost'
const DASHBOARD_PATH_PREFIX = '/dashboard'

const normalizePath = (path) => {
  if (typeof path !== 'string') {
    return ''
  }

  try {
    return decodeURIComponent(path).trim()
  } catch (error) {
    return path.trim()
  }
}

export const isDashboardAuthIntent = (path) =>
  normalizePath(path).startsWith(DASHBOARD_PATH_PREFIX)

export const shouldOpenLoginModal = ({
  redirectLink,
  storedRedirectLink,
  serviceId,
} = {}) =>
  isDashboardAuthIntent(redirectLink) ||
  isDashboardAuthIntent(storedRedirectLink) ||
  Boolean(serviceId)

export const getDashboardLoginRedirectUrl = (
  targetPath = '/dashboard/servizi'
) => `/?redirection_link=${encodeURIComponent(targetPath)}`

export function normalizeAuthRedirectPath(candidatePath) {
  if (typeof candidatePath !== 'string') {
    return null
  }

  const trimmedPath = candidatePath.trim()
  if (!trimmedPath || trimmedPath === '/' || !trimmedPath.startsWith('/')) {
    return null
  }

  if (trimmedPath.startsWith('//')) {
    return null
  }

  const parsedPath = new URL(trimmedPath, FALLBACK_BASE_URL)
  if (parsedPath.pathname === '/') {
    return null
  }

  return `${parsedPath.pathname}${parsedPath.search}${parsedPath.hash}`
}

export function getPostAuthRedirectPath(queryRedirectPath) {
  const nextQueryRedirect = normalizeAuthRedirectPath(queryRedirectPath)
  if (nextQueryRedirect) {
    return nextQueryRedirect
  }

  if (typeof window === 'undefined') {
    return null
  }

  return normalizeAuthRedirectPath(localStorage.getItem('redirection_link'))
}
